import { useSearchParams } from "react-router-dom";
import { useAppSelector } from "../store/hooks";
import { selectExtension } from "../features/extension/extension.selector";
import { useState } from "react";

export const useProductAnalyzerParams = () => {
  const [searchParams, _setSearchParams] = useSearchParams();
  const defaultAsin = searchParams.get("asin");
  const lookupId = searchParams.get("lookupId") || undefined;
  const { asin: extensionAsin } = useAppSelector(selectExtension);
  const [asin, setAsin] = useState(defaultAsin ?? extensionAsin ?? "");

  return { asin, setAsin, lookupId };
};

export default useProductAnalyzerParams;
